import { render, staticRenderFns } from "./CompanyCountryOrigin.vue?vue&type=template&id=48b68540&"
import script from "./CompanyCountryOrigin.vue?vue&type=script&lang=ts&"
export * from "./CompanyCountryOrigin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports